<div class="container personas">
  <h1 class="titulo-terminos" *ngIf="!param && languaje === 'en'">T&C MORE FARE OPTIONS</h1>
  <h1 class="titulo-terminos" *ngIf="!param && languaje === 'es'">T&C MÁS OPCIONES DE TARIFAS</h1>
  <div class="contenedor-pestanas" [style.margin]="param ? '0' : '20px 0'">
    <div class="row tab-v3">
      <div class="col-12 col-lg-3 pestanas">
        <ul class="nav nav-pills nav-stacked">
          <app-more-rate (x)="resetFlags(); tabs_state.care_protection = true" [is_active]="tabs_state.care_protection" style="width: 100%">
          </app-more-rate> 
        </ul>
      </div>
      <div class="col-12 col-lg-9 contenido">
        <div class="tab-content">
          <app-more-rate [show_content]="tabs_state.care_protection"></app-more-rate>
        </div>
      </div>
    </div> 
  </div>
</div>

